import React from 'react';
import { CheckIcon, PackageIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { volumes } from '../../data/content';
export function WhatsInside() {
  return <section className="w-full bg-white py-14 sm:py-20" data-id="element-368" data-mp="1ljbmqb0i1k3u">
      <div className="mx-auto w-full max-w-4xl px-5" data-id="element-369" data-mp="1lhs5ah33x30h">
        <p className="flex items-center gap-2 text-[0.7rem] font-bold uppercase tracking-[0.16em] text-brand-600" data-id="element-370" data-mp="1gl1mhlzx3tbd">
          <PackageIcon className="h-4 w-4" aria-hidden="true" data-id="element-371" data-mp="1cjy7f1pp21b7" />
          What’s inside
        </p>
        <h2 className="mt-3 font-display text-[1.7rem] font-extrabold leading-tight tracking-tight text-navy-900 sm:text-4xl" data-id="element-372" data-mp="17isd4zgdy5zk">
          You Are Not Getting Another Ebook.
        </h2>
        <p className="mt-3 text-[1.05rem] font-semibold leading-snug text-brand-700 sm:text-xl" data-id="element-373" data-mp="xmfo4evscgb5">
          You are getting a complete clinical decision system for erectile
          dysfunction.
        </p>
        <div className="mt-4 space-y-1.5 text-[0.95rem] text-slate-600" data-id="element-374" data-mp="2s0qckm8gx8ge">
          <p data-id="element-375" data-mp="1koy5xnw19ngw">Each volume addresses a specific stage of the consultation.</p>
          <p data-id="element-376" data-mp="1kr18t8iabb31">Each algorithm helps organize a decision.</p>
          <p data-id="element-377" data-mp="1poj7m62l89xb">Each checklist reduces the need to start from scratch.</p>
        </div>

        <h3 className="mt-10 rounded-2xl bg-navy-900 px-5 py-4 text-center font-display text-sm font-extrabold uppercase leading-snug tracking-[0.1em] text-white sm:text-base" data-id="element-378" data-mp="1araeb6tq4w2y">
          The complete 6-volume Clinical Route for Erectile Dysfunction™
        </h3>

        <div className="mt-6 space-y-5" data-id="element-379" data-mp="28e9c5kw5ka2f">
          {volumes.map(volume => <article key={volume.roman} className="overflow-hidden rounded-3xl border border-slate-200 bg-slate-50" data-id="element-380" data-mp="28gbz1w20dn2x">
              <div className="flex items-center gap-4 bg-navy-900 px-5 py-4" data-id="element-381" data-mp="1yneezlhdbq27">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-white/20 bg-white/10 font-display text-base font-extrabold text-cyan-bright" data-id="element-382" data-mp="2mdif3ivcl7og">
                  {volume.roman}
                </span>
                <div data-id="element-383" data-mp="3107gxrd2nwy0">
                  <p className="text-[0.65rem] font-bold uppercase tracking-[0.18em] text-slate-400" data-id="element-384" data-mp="30yd5d3noxh6l">
                    {volume.index}
                  </p>
                  <h4 className="font-display text-lg font-extrabold leading-tight text-white sm:text-xl" data-id="element-385" data-mp="2ryq0u8znzv9b">
                    {volume.title}
                  </h4>
                </div>
              </div>

              <div className="px-5 py-5" data-id="element-386" data-mp="2i3fytl99nnvj">
                <p className="font-semibold leading-snug text-navy-800" data-id="element-387" data-mp="2db50uny36c5m">
                  {volume.promise}
                </p>
                {volume.intro.map(paragraph => <p key={paragraph} className="mt-2.5 text-[0.92rem] leading-relaxed text-slate-600" data-id="element-388" data-mp="289z7cnwlqkv1">
                    {paragraph}
                  </p>)}

                <p className="mt-5 text-[0.7rem] font-bold uppercase tracking-[0.14em] text-brand-600" data-id="element-389" data-mp="1ubr1fqhl897q">
                  Includes
                </p>
                <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-390" data-mp="9u02xmd4nlnr">
                  {volume.includes.map(item => <li key={item} className="flex items-start gap-2 text-[0.88rem] leading-snug text-slate-700" data-id="element-391" data-mp="ev5v9j2vl6wr">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" aria-hidden="true" data-id="element-392" data-mp="nt824f9aitry" />
                      {item}
                    </li>)}
                </ul>
              </div>
            </article>)}
        </div>

        <div className="mx-auto mt-10 max-w-md" data-id="element-393" data-mp="4uwv5u5rj1c3">
          <CTAButton label="I want all 6 volumes now" note="Immediate digital access" data-id="element-394" data-mp="4wq45g3ulxn9" />
        </div>
      </div>
    </section>;
}